import RiotsTable from '../../../assets/js/Articles/RiotsTable/InitTable.js';
RiotsTable();